import TraderOrderModal from '@/components/modal/TraderOrderModal';
import ModuleWindow, { moduleHeaderClassName } from '@/components/mosaic/ModuleWindow';
import ModuleWindowControls from '@/components/mosaic/ModuleWindowControl';
import { roundedFullClassname } from '@/helpers/environmentHelper';
import { ModalOperations } from '@/model/common';
import { useDisclosure } from '@/utils/hooks/useDisclosure';
import useLanguage from '@/utils/hooks/useLanguage';
import cn from 'classnames';
import { Fragment, useState } from 'react';
import { MdHardware } from 'react-icons/md';
import TickersModuleBody from './TickersModuleBody';

const TickersModule = (props: any) => {
    const { screen, tradingModule } = props;

    const lang = useLanguage();

    const orderDisclosure = useDisclosure(false);

    const [showControls, setShowControls] = useState<boolean>(true);
    const [modalMode, setModalMode] = useState<ModalOperations>('Create');

    return (
        <Fragment>
            <ModuleWindow
                {...props}
                renderToolbar={() => (
                    <div className={moduleHeaderClassName} dir={lang.dir}>
                        <span className="p-2 font-semibold">{tradingModule.title}</span>
                        <div className="flex h-full items-center">
                            <div
                                className={cn(
                                    'relative cursor-pointer flex items-center h-8 py-2 pl-3 pr-8 text-xs leading-none text-brand-text hover:bg-brand-primary bg-brand-background-dark mr-0.5 rounded-sm',
                                    roundedFullClassname
                                )}
                                onClick={() => setShowControls(!showControls)}>
                                <span className="text-xs leading-none">
                                    {showControls ? lang.tickers.collapse : lang.tickers.expand} {lang.tickers.tools}
                                </span>
                                <div className="absolute inset-y-0 right-0 flex items-center pr-2">
                                    <MdHardware className="h-4 w-4 rotate-45" />
                                </div>
                            </div>
                            <ModuleWindowControls screen={screen} />
                        </div>
                    </div>
                )}>
                <TickersModuleBody
                    showControls={showControls}
                    modalMode={modalMode}
                    setModalMode={setModalMode}
                    orderDisclosure={orderDisclosure}
                />
            </ModuleWindow>
            <TraderOrderModal opened={orderDisclosure[0]} handlers={orderDisclosure[1]} />
        </Fragment>
    );
};

export default TickersModule;
